var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-menu',{key:"language-menu",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"text--secondary px-0 px-md-2",attrs:{"icon":_vm.$vuetify.breakpoint.smAndDown,"text":""}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("$mdiTranslate")]),_c('app-chevron-down')],1)]}},{key:"item",fn:function(ref){
var index = ref.index;
var item = ref.item;
return [_c('v-list-item',{key:index,staticClass:"v-list-item--default",attrs:{"to":{ params: { locale: item.alternate || item.locale } },"replace":""}},[_c('v-list-item-title',{domProps:{"textContent":_vm._s(item.title)}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }